var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipe"},[_c('transition-group',{attrs:{"name":"fadeIn","tag":"ul"}},_vm._l((_vm.piclist),function(item,index){return _c('li',{key:item.id,style:(_vm.config[index])},[_c('img',{attrs:{"src":item.url}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }